export default __webpack_public_path__ + "static/media/11.87331e88.png";